import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PricingScan } from './components/PricingScan';
import { WebsitesPage } from './pages/WebsitesPage';
import { HostingPage } from './pages/HostingPage';
import { SEOPage } from './pages/SEOPage';
import { SEOBlogPage } from './pages/SEOBlogPage';
import { EmailPage } from './pages/EmailPage';
import { SollicitatiePage } from './pages/SollicitatiePage';
import { VacaturePage } from './pages/VacaturePage';
import { BibliotheekPage } from './pages/BibliotheekPage';
import { ClientCasePage } from './pages/ClientCasePage';
import { OverOnsPage } from './pages/OverOnsPage';
import { TeamLid1Page } from './pages/TeamLid1Page';
import { TeamLid2Page } from './pages/TeamLid2Page';
import { TeamLid3Page } from './pages/TeamLid3Page';
import { TeamLid4Page } from './pages/TeamLid4Page';
import { TeamLidJellePage } from './pages/TeamLidJellePage';
import { TeamLidLoisPage } from './pages/TeamLidLoisPage';
import { TeamLidJessePage } from './pages/TeamLidJessePage';
import { AlgemeneVoorwaardenPage } from './pages/AlgemeneVoorwaardenPage';
import { PrivacybeleidPage } from './pages/PrivacybeleidPage';
import { CookiebeleidPage } from './pages/CookiebeleidPage';
import { CookieBanner } from './components/CookieBanner';
export function AppRouter() {
  return <BrowserRouter data-id="element-17">
      <Routes data-id="element-18">
        <Route path="/" element={<App data-id="element-20" />} data-id="element-19" />
        <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaardenPage data-id="element-22" />} data-id="element-21" />
        <Route path="/privacy" element={<PrivacybeleidPage data-id="element-24" />} data-id="element-23" />
        <Route path="/cookiebeleid" element={<CookiebeleidPage data-id="element-26" />} data-id="element-25" />
        <Route path="/prijsscan" element={<PricingScan data-id="element-28" />} data-id="element-27" />
        <Route path="/website-laten-maken-financieel-adviseur" element={<WebsitesPage data-id="element-30" />} data-id="element-29" />
        <Route path="/websites" element={<WebsitesPage data-id="element-32" />} data-id="element-31" />
        <Route path="/zakelijke-hosting-financieel-adviseur" element={<HostingPage data-id="element-34" />} data-id="element-33" />
        <Route path="/hosting" element={<HostingPage data-id="element-36" />} data-id="element-35" />
        <Route path="/seo-financieel-adviseur" element={<SEOPage data-id="element-38" />} data-id="element-37" />
        <Route path="/seo" element={<SEOPage data-id="element-40" />} data-id="element-39" />
        <Route path="/seo/blog/:slug" element={<SEOBlogPage data-id="element-42" />} data-id="element-41" />
        <Route path="/zakelijke-email-hosting" element={<EmailPage data-id="element-44" />} data-id="element-43" />
        <Route path="/email" element={<EmailPage data-id="element-46" />} data-id="element-45" />
        <Route path="/sollicitatie" element={<SollicitatiePage data-id="element-48" />} data-id="element-47" />
        <Route path="/vacature/:slug" element={<VacaturePage data-id="element-50" />} data-id="element-49" />
        <Route path="/bibliotheek" element={<BibliotheekPage data-id="element-52" />} data-id="element-51" />
        <Route path="/cases/:slug" element={<ClientCasePage data-id="element-54" />} data-id="element-53" />
        <Route path="/over-ons" element={<OverOnsPage data-id="element-56" />} data-id="element-55" />
        <Route path="/over-ons/rocco" element={<TeamLid1Page data-id="element-58" />} data-id="element-57" />
        <Route path="/over-ons/beer" element={<TeamLid2Page data-id="element-60" />} data-id="element-59" />
        <Route path="/over-ons/alex" element={<TeamLid3Page data-id="element-62" />} data-id="element-61" />
        <Route path="/over-ons/norden" element={<TeamLid4Page data-id="element-64" />} data-id="element-63" />
        <Route path="/over-ons/jelle" element={<TeamLidJellePage data-id="element-66" />} data-id="element-65" />
        <Route path="/over-ons/lois" element={<TeamLidLoisPage data-id="element-68" />} data-id="element-67" />
        <Route path="/over-ons/jesse" element={<TeamLidJessePage data-id="element-70" />} data-id="element-69" />
      </Routes>
      <CookieBanner data-id="element-71" />
    </BrowserRouter>;
}